<script> 
	import { 
		headerTitleHome, 
		linkAV, 
		linkAVConheca, 
		linkPesquisaVendas,
		linkPesquisaLocacao,
		textSite,
		linkFacebook,
		linkInstagram
	} from '../store.js';
	
	import { link }         from "svelte-routing";
	import KenBurns         from '../components/KenBurns.svelte'
	import Vitrine          from '../components/Vitrine.svelte'
	import Busca            from '../components/Busca.svelte'
	import ListaImoveis     from '../components/ListaImoveis.svelte'
	import Boleto           from '../components/Boleto.svelte'
	import Atendimento      from '../components/Atendimento.svelte'
	import Instagram		from '../components/Instagram.svelte'
	import PopUp			from '../components/PopUp.svelte'
	

	let vitrines = [
		{
			image: 'vitrineCanais.png', 
			imageMobile: 'vitrineCanaisM.png', 
			title: 'Canais digitais',
			href: '/contato'
		},
	];

	/* Imóveis */ 
	function search(e) {
		const url = '/imoveis/' + (e.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(e.detail).filter(p=>p[1].length>0).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}
	
	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, cidade:'Canela', pageSize:6, random: true};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, cidade:'Canela', pageSize:6, random: true};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao', json.NumberOfItems);
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas', json.NumberOfItems);
		}
	}
	function activateSlick(selector, count) {
		let max = count >= 3 ? 3 : (count >= 2 ? 2 : 1);
		let min = count >= 2 ? 2 : 1;
		window.setTimeout(() => {
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: max,
				slidesToScroll: max,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 850,
						settings: {
							slidesToShow: min,
							slidesToScroll: min,
							dots: true,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
						}
					}
				]            
			});
		}, 500);
	}

	
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<h1 class="text-seo">{$headerTitleHome}</h1>

<KenBurns>
	<section class="busca-inline">
		<div class="container">
			<Busca style="home" on:filter={search} /> 
		</div>
	</section>
</KenBurns>

<div class="container mt-50">
	<Vitrine vitrines={vitrines} vitrineHeight="260px"/>
</div>

<!-- Destaques Locação -->
<section style="display: none;" class="section destaques-home destaques-home--locacao mb-50">
	<div class="container">
		<div class="header">
			<h2 class="title color-primary">Destaques para <b>Alugar</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaLocacao}" title="Ofertas para alugar - {$textSite}">
				<i class="fas fa-plus-circle"></i> <b class="color-primary">Ver todos imóveis</b>
			</a>                
		</div>
		<ListaImoveis filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
	</div>
</section>

<!--Aplicativo-->
<section class="section section-aplicativo mt-10">
	<div class="container">
		<div class="box">
			<div class="text-center mb-20">
				<img class="img-fluid" src="/assets/images/logo.png" alt="SP Imobiliária" />
			</div>
			<p class="no-breakline--xs color-primary mt-10 mb-10">Todos os serviços em um único lugar. <br> Utilize no tablet, celular ou computador. <br> Comunicação rápida, prática e segura.</p>
			<div class="buttons">
				<a href={$linkAVConheca} target="_blank" class="hover-transform btn btn-secondary" title="Saiba mais {$textSite}">Saiba mais</a>
				<a href={$linkAV} target="_blank" class="hover-transform btn btn-primary" title="Acesse o {$textSite}">Acesse agora</a>
			</div>
		</div>
	</div>
</section>

<!-- Destaques Comprar -->
<!-- 
<section style="display: none;" class="section destaques-home destaques-home--vendas mb-50">
	<div class="container">
		<div class="header">
			<h2 class="title color-primary">Destaques para <b>Comprar</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaVendas}" title="Ofertas para Comprar - {$textSite}">
				<i class="fas fa-plus-circle"></i> <b class="color-primary">Ver todos imóveis</b>
			</a>                
		</div>
		<ListaImoveis filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
	</div>
</section>
-->

<section class="section instagram mb-50">
	<div class="container">
		<div class="header">
			<h2 class="title color-primary">Acompanhe nossas redes</h2>
			<div class="link">
				<a target="_blank" class="icon-transform" href="{$linkFacebook}" title="Ir para o Facebook">
					<i class="fab fa-facebook-square"></i> <b class="color-primary">Facebook</b>
				</a>
				<a target="_blank" class="icon-transform ml-10" href="{$linkInstagram}" title="Ir para o Instagram">
					<i class="fab fa-instagram"></i> <b class="color-primary">Instagram</b>
				</a>
			</div>
		</div>
		<div class="mt-30">
			<Instagram />
		</div>
	</div>
</section>

<Boleto />

<PopUp channel="site" />